import { defineMessages } from 'react-intl'

const translations = defineMessages({
  subscribe: {
    defaultMessage: 'Convert Order to Subscription',
    id: 'msp.account.order_history.order_detail.action.subscription'
  },
  subscriptionTitle: {
    defaultMessage: 'Set up a subscription',
    id: 'msp.account.order_history.order_detail.action.subscriptionTitle'
  }
})

export default translations
